interface LoadingStateProps {
    message?: string
    className?: string
}

export function LoadingState({ message = 'Loading...', className }: LoadingStateProps) {
    return (
        <div
            className={`bg-white/60 dark:bg-slate-900/60 backdrop-blur-xl rounded-2xl border border-white/40 dark:border-slate-700/40 p-8 min-h-[400px] flex flex-col items-center justify-center ${className || ''}`}
        >
            <div className="w-12 h-12 border-4 border-indigo-500/30 dark:border-indigo-400/30 border-t-indigo-500 dark:border-t-indigo-400 rounded-full animate-spin" />
            <p className="mt-4 text-slate-500 dark:text-slate-400 font-medium">{message}</p>
        </div>
    )
}
